import React from 'react';

function MatchingStatusDisplay({ status }) {
    return <p className="status-text">{status}</p>;
}

export default MatchingStatusDisplay;